import React from 'react'

import { Absolute, Relative } from '../helpers/Position'
import { SmallText } from './Text'
import Circle from '../shapes/Circle'

const EMPTY_SIZE = 0.4
const VALUE_SIZE = 0.9
const DISTANCE_TOP = 0
const DISTANCE_RIGHT = -0.4

const Badge = ({ children, color, count, icon }) => {
  if (!color && !count && !icon) return children

  const size = !!count || !!icon ? VALUE_SIZE : EMPTY_SIZE

  const distanceTop = DISTANCE_TOP - (size - EMPTY_SIZE) / 1.5
  const distanceRight = DISTANCE_RIGHT - (size - EMPTY_SIZE) / 2

  return (
    <Relative display="inline-block" zIndex="auto">
      {children}
      <Absolute top={distanceTop} right={distanceRight} zIndex="auto">
        <Circle bgColor={color || 'blue'} size={size}>
          <SmallText bold color="white" align="center" hideIfEmpty size="xxsmall">
            {count}
          </SmallText>
        </Circle>
      </Absolute>
    </Relative>
  )
}

export default Badge
